import React, {Component} from 'react'
import { connect } from 'react-redux'

// import styles
import './orderinspection.scss'

// Actions
import { getOrderInspectionInformation, saveOrderInspectionInformation } from '../../../actions/settings'

// Components
// import HelpText from '../../../shared/components/HelpText'

import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Check from '../../../shared/elements/check'
import Switch from '../../../shared/elements/switch'
import Text from '../../../shared/elements/text'
import AddButton from '../../../shared/elements/addButton'
import RemoveButton from '../../../shared/elements/removeButton'
import Grid from '../../../shared/elements/grid'
import Label from '../../../shared/elements/label'

// Utils
import { hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

class OrderInspection extends Component {

  constructor (props) {
    super(props)
    this.state = {
      NewItem: {
        Text: '',
        Deleted: false
      },
      OrderInspection: {
        ShopId: 0,
        Active: false,
        Claim: false,
        ExternalWork: false,
        Assessment: false,
        MissingParts: false,
        Color: false,
        ProcessComment: false,
        Deadline: false,
        OtherDamage: false,
        AdditionalInspections: []
      }
    }
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.getOrderInspectionInformation()
  }

  getOrderInspectionInformation () {
    this.props.getOrderInspectionInformation(this.props.auth.user.ShopId).then((res) => {
      this.setState({
        OrderInspection: {
          ShopId: res.data.ShopId,
          Active: res.data.Active,
          Claim: res.data.Claim,
          ExternalWork: res.data.ExternalWork,
          Assessment: res.data.Assessment,
          MissingParts: res.data.MissingParts,
          Color: res.data.Color,
          ProcessComment: res.data.ProcessComment,
          Deadline: res.data.Deadline,
          OtherDamage: res.data.OtherDamage,
          AdditionalInspections: res.data.AdditionalInspections
        }})
    }, (err) => {
      console.log(err)
    })
  }

  updateOrderInspection (orderInspection) {
    return this.props.saveOrderInspectionInformation(orderInspection).then((res) => {
      this.setState({
        OrderInspection: {
          ShopId: res.data.ShopId,
          Active: res.data.Active,
          Claim: res.data.Claim,
          ExternalWork: res.data.ExternalWork,
          Assessment: res.data.Assessment,
          MissingParts: res.data.MissingParts,
          Color: res.data.Color,
          ProcessComment: res.data.ProcessComment,
          Deadline: res.data.Deadline,
          OtherDamage: res.data.OtherDamage,
          AdditionalInspections: res.data.AdditionalInspections
        }
      })
      return res
    }, (err) => {
      console.log(err)
      return err
    })
  }

  onBlur (e) {
    this.props.saveOrderInspectionInformation(this.state.OrderInspection).then(() => {
      // Toastr (replace dict. key)
      // window.toastr.success(translation('1726'), translation('13424'))
    }, () => {
      // Toastr (replace dict. key)
      window.toastr.error(translation('1727'), translation('216'))
    })
  }

  onChange (e) {
    e.persist()
    let value = e.target.value
    if (e.target.type === 'radio') {
      value = (e.target.value === 'yes')
    } else if (e.target.type === 'checkbox') {
      value = e.target.checked
    }
    this.setState({
      OrderInspection: {
        ...this.state.OrderInspection,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.type === 'radio' || e.target.type === 'checkbox') {
        this.onBlur(e)
      }
    })
  }

  render () {
    let inspection = this.state.OrderInspection

    return (
      <div className='orderinspection__page'>
        <Row>
          <Col>
            <Panel title={translation('13423')} helpText={translation('1988')}>
              <Switch name='Active' onChange={this.onChange} checked={inspection.Active} labelText={translation('295')} />

              <Check id='Claim' name='Claim' value='1' checked={inspection.Claim} onChange={this.onChange} labelText={translation('301')} />
              {this.props.auth.departmentType === 0 && (
                <Check id='ExternalWork' name='ExternalWork' value='1' checked={inspection.ExternalWork} onChange={this.onChange} labelText={translation('1012')} />
              )}
              <Check id='Assessment' name='Assessment' value='1' checked={inspection.Assessment} onChange={this.onChange} labelText={translation('801')} />
              {this.props.auth.departmentType === 0 && (
                <Check id='MissingParts' name='MissingParts' value='1' checked={inspection.MissingParts} onChange={this.onChange} labelText={translation('13456')} />
              )}
              <Check id='Color' name='Color' value='1' checked={inspection.Color} onChange={this.onChange} labelText={translation('179')} />
              <Check id='ProcessComment' name='ProcessComment' value='1' checked={inspection.ProcessComment} onChange={this.onChange} labelText={translation('1729')} />

              {hasSubscriptionPermission(this.props.auth, 20) && (
                <Check id='Deadline' name='Deadline' value='1' checked={inspection.Deadline} onChange={this.onChange} labelText={translation('1232')} />
              )}

              {this.props.auth.departmentType !== 0 && (
                <Check id='OtherDamage' name='OtherDamage' value='1' checked={inspection.OtherDamage} onChange={this.onChange} labelText={translation('15188')} />
              )}
            </Panel>
          </Col>

          {hasSubscriptionPermission(this.props.auth, 10, 24) && this.renderCustomInspections()}
        </Row>
      </div>
    )
  }

  renderCustomInspections () {
    let cols = ['auto', '48px']
    let { OrderInspection } = this.state
    const deleteItem = (key) => {
      let customInspection = {...this.state.OrderInspection}
      customInspection.AdditionalInspections[key].Deleted = true
      this.updateOrderInspection(OrderInspection)
    }

    const renderNew = () => {
      const addItem = () => {
        let OrderInspection = {...this.state.OrderInspection}
        let newItem = {...this.state.NewItem}
        OrderInspection.AdditionalInspections.push(newItem)
        this.updateOrderInspection(OrderInspection).then((res) => {
          this.setState({
            NewItem: {
              CustomInspectionId: 0,
              Text: '',
              Deleted: false
            }
          })
          // Toastr (replace dict. key)
          // window.toastr.success(translation('1726'), translation('13424'))
        }, () => {
          // Toastr (replace dict. key)
          window.toastr.error(translation('1727'), translation('216'))
        })
      }

      const onChange = (e) => {
        this.setState({
          NewItem: {
            ...this.state.NewItem,
            [e.target.name]: e.target.value
          }
        })
      }

      return (
        <Grid cols={cols} spacing={1}>
          <Text name='Text' value={this.state.NewItem.Text} onChange={onChange} />
          <AddButton spacing={0} onClick={addItem} />
        </Grid>
      )
    }

    const renderCustomInspection = (val, key) => {
      const onChange = (e) => {
        let inspectionNew = {...this.state.OrderInspection}
        inspectionNew.AdditionalInspections[key][e.target.name] = e.target.value
        this.setState({
          OrderInspection: inspectionNew
        })
      }

      return (
        <Grid cols={cols} key={key} spacing={1}>
          <Text name='Text' defaultValue={val.Text} onChange={onChange} onBlur={this.onBlur} key={'customInspection_' + val.Id} size='m' />
          <RemoveButton spacing={0} onClick={deleteItem.bind(this, key)} size='m' />
        </Grid>
      )
    }

    return (
      <Col>
        <Panel title={translation('1730')} helpText={translation('1989')}>
          <div>
            <Grid cols={cols} spacing={1}>
              <Label>{translation('1021')}</Label>
              <div />
            </Grid>
            {renderNew()}
            {OrderInspection.AdditionalInspections.map(renderCustomInspection)}
          </div>
        </Panel>
      </Col>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getOrderInspectionInformation,
  saveOrderInspectionInformation
})(OrderInspection)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/OrderInspection/index.js